import React from 'react';
import InputToggle from './components/InputToggle';
import { WrapperInputToggle } from './styled';
import type { TActionState, TActionState2 } from './types';
import type { TFullName, TProfile, TProfileData } from '../../helpers/format';
import Processing from '@/presentation/components/Processing';
import Modal from '@/presentation/modules/procedures/components/Modal/Modal';
import ContentModalOneButton from '@/presentation/modules/procedures/components/ContentModalOneButton';
import ValidationDialog from './components/ValidationDialog';
import ConfirmDialog from './components/ConfirmDialog';
import MessageDialog from './components/MessageDialog';
import InputToggleOld from './components/InputToggleOld';
import PopPupRestriction from '@/presentation/reusables/PopRestriction';
import WarningMessage from '@/presentation/reusables/WarningMessage';
import Link from '@/presentation/reusables/Link';

interface IProps {
  actionState: TActionState;
  profile: TProfile;
  profileData: TProfileData;
  fullName: TFullName;
  controllerActionState: (state: Partial<TActionState>) => void;
  onValidatingCode: (validationCode: number) => void;
  status: {
    sendCodeStatus: any;
    validateCodeStatus: any;
    updateProfile: any;
  };
  loaders: {
    isSendingCode: boolean;
    isValidatingCode: boolean;
    isUpdatingData: boolean;
    isUpdatingDataProfile: boolean;
  };
  restrictionProps: {
    restriction: boolean;
    setRestriction: (show: boolean) => void;
  };
  isLoadingMasters: boolean;
  onClearCode: () => void;
}

const PersonalInformationView = ({
  actionState,
  profile,
  profileData,
  fullName,
  controllerActionState,
  onValidatingCode,
  loaders,
  status,
  isLoadingMasters,
  onClearCode,
  restrictionProps
}: IProps) => (
  <>
    <Processing
      isOpen={
        loaders.isSendingCode ||
        loaders.isUpdatingData ||
        loaders.isValidatingCode ||
        loaders.isUpdatingDataProfile
      }
    />
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        marginBottom: '105px'
      }}
    >
      <WrapperInputToggle>
        <InputToggleOld
          actionState={actionState}
          controllerActionState={controllerActionState}
          inputType="PHONE"
          profile={profile}
        />
        <InputToggleOld
          actionState={actionState}
          controllerActionState={controllerActionState}
          inputType="EMAIL"
          profile={profile}
        />
        {profile?.emailPermission && profile?.phonePermission && (
          <WarningMessage
            message={
              <>
                Solo puedes{' '}
                <span
                  style={{
                    fontWeight: '700',
                    fontSize: '14px',
                    lineHeight: '20px'
                  }}
                >
                  actualizar estos datos (1) vez al día.
                </span>{' '}
                Esta actualización se mostrarán en todas tus plataformas
                digitales UTP.
              </>
            }
            styledProps={{ background: '#D5E5F0', padding: '16px' }}
          />
        )}
      </WrapperInputToggle>
      <WrapperInputToggle>
        <InputToggle
          actionState={actionState}
          controllerActionState={controllerActionState}
          inputType="NAMES"
          profileData={profileData}
          fullName={fullName}
          hasActionCrud={false}
          testId="document-toggle-button"
          isLoadingMasters={isLoadingMasters}
        />
        <InputToggle
          actionState={actionState}
          controllerActionState={controllerActionState}
          inputType="SURNAMES"
          profileData={profileData}
          fullName={fullName}
          hasActionCrud={false}
          testId="document-toggle-button"
          isLoadingMasters={isLoadingMasters}
        />
        <InputToggle
          actionState={actionState}
          controllerActionState={controllerActionState}
          inputType="DOCUMENT_NUMBER"
          profileData={profileData}
          fullName={fullName}
          hasActionCrud={false}
          testId="document-toggle-button"
          isLoadingMasters={isLoadingMasters}
        />
        <InputToggle
          actionState={actionState}
          controllerActionState={controllerActionState}
          inputType="BIRTHDATE"
          profileData={profileData}
          fullName={fullName}
          hasActionCrud={false}
          testId="birthdate-toggle-button"
          isLoadingMasters={isLoadingMasters}
        />
        <WarningMessage
          message={
            <>
              Si los datos mostrados contienen errores, registra una{' '}
              <Link
                linkType="internal"
                url="/tramites/ticketera/registro?v=TA0001"
                linkName="solicitud de SAE."
              />
            </>
          }
          styledProps={{ background: '#D5E5F0', padding: '16px' }}
        />
      </WrapperInputToggle>
      <WrapperInputToggle>
        <InputToggle
          actionState={actionState}
          controllerActionState={controllerActionState}
          inputType="CIVIL_STATUS"
          profileData={profileData}
          fullName={fullName}
          testId="civil-toggle-button"
          hasActionCrud
          isLoadingMasters={isLoadingMasters}
        />
        <hr style={{ background: '#A8CBE2', border: '1px solid #A8CBE2' }} />
        <InputToggle
          actionState={actionState}
          controllerActionState={controllerActionState}
          inputType="HOME_ADDRESS"
          profileData={profileData}
          fullName={fullName}
          // defaultValue={profileData?.maritalStatus}
          testId="civil-toggle-button"
          isLoadingMasters={isLoadingMasters}
        />
        <hr style={{ background: '#A8CBE2', border: '1px solid #A8CBE2' }} />
        <InputToggle
          actionState={actionState}
          controllerActionState={controllerActionState}
          inputType="TYPE_MOBILITY"
          profileData={profileData}
          fullName={fullName}
          defaultValue={profileData?.maritalStatus}
          testId="civil-toggle-button"
          isLoadingMasters={isLoadingMasters}
        />
        <hr style={{ background: '#A8CBE2', border: '1px solid #A8CBE2' }} />
        <InputToggle
          actionState={actionState}
          controllerActionState={controllerActionState}
          inputType="EMERGENCY_CONTACT"
          profileData={profileData}
          fullName={fullName}
          defaultValue={profileData?.maritalStatus}
          testId="civil-toggle-button"
          isLoadingMasters={isLoadingMasters}
        />
      </WrapperInputToggle>
    </div>
    {!restrictionProps.restriction &&
      !status?.sendCodeStatus?.status?.includes('EXCEDISTE') &&
      !status?.sendCodeStatus?.status?.includes('ERROR') &&
      !status?.sendCodeStatus?.status?.includes('ESPERAR') && (
        <ValidationDialog
          actionState={actionState}
          controllerActionState={controllerActionState}
          onValidatingCode={onValidatingCode}
        />
      )}
    {status?.sendCodeStatus?.status?.includes('EXCEDISTE') && (
      <Modal show handleClose={onClearCode}>
        <ContentModalOneButton
          title="Ya excediste la cantidad de generaciones de códigos permitidos por día."
          showInfo={false}
          textButton="Aceptar"
          onClickButton={onClearCode}
        />
      </Modal>
    )}
    {status?.sendCodeStatus?.status?.includes('ESPERAR') && (
      <Modal show handleClose={onClearCode}>
        <ContentModalOneButton
          title="Espera 3 minutos para poder solicitar un código nuevo"
          showInfo={false}
          textButton="Aceptar"
          onClickButton={onClearCode}
        />
      </Modal>
    )}
    {(actionState?.input === 'PHONE' || actionState?.input === 'EMAIL') && (
      <>
        <ConfirmDialog
          actionState={actionState}
          controllerActionState={controllerActionState}
        />
        <MessageDialog
          actionState={{ ...actionState } as TActionState2}
          controllerActionState={controllerActionState}
          isPhone={actionState?.input === 'PHONE'}
        />
      </>
    )}
    <Modal
      show={restrictionProps.restriction}
      handleClose={() => {
        restrictionProps.setRestriction(false);
        controllerActionState({
          action: 'DEFAULT',
          code: '',
          status: 'DEFAULT'
        });
      }}
    >
      <PopPupRestriction
        handleClick={() => {
          restrictionProps.setRestriction(false);
          controllerActionState({
            action: 'DEFAULT',
            code: '',
            status: 'DEFAULT'
          });
        }}
      />
    </Modal>
  </>
);

export default PersonalInformationView;
